import React from 'react';
// Data
import { testimonialsArray } from '../../utils/data/ReviewData';

function TestimonialSection() {
  return (
    <section id='testimonials' className='grid bg-colour1 lg:pt-4'>
      <div className='grid lg:gap-10 px-6 bg-colour1 sm:px-16 lg:px-20 max-w-3xl lg:max-w-7xl mx-auto text-center py-8'>
        <section className='grid h-fit gap-2 lg:gap-4'>
          <div>
            <span className='text-2xl font-bold lg:text-4xl'>TESTIMONIALS</span>
          </div>
          <div className='text-xl leading-5'>
            <p>
              My customers are overwhelmingly kind and appreciated my hard work
            </p>
          </div>
        </section>
        <div className='grid gap-6 mt-6 lg:grid-cols-3'>
          {testimonialsArray.map((testimonial, index) => (
            <article
              key={index}
              className={`grid items-center border rounded-lg ${
                index === 0
                  ? 'bg-colour4'
                  : index === 1
                  ? 'bg-colour5'
                  : index === 2
                  ? 'bg-colour6'
                  : ''
              } text-colour1 shadow-cardShadowBold overflow-hidden`}
            >
              <div className='grid h-full px-4 py-6'>
                <section>
                  <h6 className='text-xl font-bold font-newsweekly uppercase'>
                    {testimonial.name}
                  </h6>
                  <div className='px-4'>
                    <p className='text-sm opacity-75'>{testimonial.date}</p>
                    <p className='mt-2 italic'>{testimonial.review}</p>
                  </div>
                </section>
                <div className='pt-3 grid items-end neon_text'>{'★★★★★'}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialSection;
